<template>
  <div class="cmp-booking-tasks-task_list dt-page">
    <NTable
      id="booking-tasks-task_list"
      class="h1"
      :config="tableConfig"
      :items="loggedUserTasks"
      :headers="headers"
      :loadingFlag="loadingFlag"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr @click="onRowClicked(item.external_id)">
          <td v-bind="tdcon('related_bookings')">
            <span>
              {{ item["start_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('must_do_task_checklist')">
              <InfoCard
                :label="item['name_group'] || ''"
                :infoString="item['name_group'] || ''"
              />
          </td>
          <td v-bind="tdcon('city')">
            <span>
              {{ item.city + ", " + item.iso2 }}
            </span>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";

import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../plugins/datatable";
import { bookingListCalendarDateTabRoute } from "../router/router";
import InfoCard from "../../../dt-plugins/info-card/info-card.vue";

export default {
  components: {
    NTable,
    InfoCard,
  },
  data: function () {
    return {
      tasks: [],

      loadingFlag: false,
    };
  },
  mounted: function () {
    this.fetchList();
  },
  computed: {
    ...mapGetters(storeNS, {
      loggedUserTasks: "loggedUserTasks",
    }),
    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    headers: function () {
      return [
        createTableHeader("related_bookings", { fw: 700, f: 0.2 }),
        createTableHeader("must_do_task_checklist", {f: 0.6}),
        createTableHeader("city", {f: 0.2}),
      ];
    },
  },
  watch: {},
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GET_LOGGED_USER_TASKS]:
        ActionTypes.GET_LOGGED_USER_TASKS,
    }),
    async fetchList() {
      this.loadingFlag = true;
      await this[ActionTypes.GET_LOGGED_USER_TASKS]();
      this.loadingFlag = false;
    },
    onRowClicked(calendar_date_id) {
      this.$router.push({
        name: bookingListCalendarDateTabRoute,
        params: { calendar_date_id, tab: "overview" },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-ntable {
  --ntable-height: calc(100vh - 135px);
}
</style>
